<template>
    <div>
        <div v-if="passed_filter">
            <div class="designeroption" data-designer-component-id="measurements">
                <h3>Measurements</h3>
                <div class="stylesoption">
                    <div :class="['form-group', !valid_door ? 'has-error' : '']">
                        <label :class="[!valid_door ? 'text-danger' : '']" v-html="doorWidthAndHeightLabel"></label>
                        <span :class="[!valid_door_width ? 'text-danger' : '']">{{ door_width }}mm</span> x <span
                        :class="[!valid_door_height ? 'text-danger' : '']">{{ door_height }}mm</span>
                    </div>
                    <div v-for="measurement in measurements"
                         :class="['form-group mt-6', target[measurement.slug] === undefined || target[measurement.slug] > limits[measurement.slug].max || target[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                        <label :for="component_id + '_' + measurement.slug">{{ measurement.title }}
                            <template v-if="loading">(Checking Min/Max...)</template>
                            <template v-if="!loading">({{ limits[measurement.slug].min }}mm to
                                {{ limits[measurement.slug].max }}mm)
                            </template>
                        </label>
                        <input :dusk="measurement.slug" :id="component_id + '_' + measurement.slug" type="number"
                               v-model="target[measurement.slug]" class="form-control"
                               :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}"
                               max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey"
                               @input="filterInput">
                        <div class="mt-3" v-if="measurement.slug === 'overall_width' && (extra_width_text !== null)" v-html="extra_width_text"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Question from "./mixin/Question.vue";
import {nextTick} from "vue";

export default {
    mixins: [
        Question,
    ],
    computed: {
        valid_door() {
            return this.valid_door_width && this.valid_door_height;
        },
        valid_door_width() {
            return this.door_width <= this.limits.door_width.max
                && this.door_width >= this.limits.door_width.min;
        },
        valid_door_height() {
            return this.door_height <= this.limits.door_height.max
                && this.door_height >= this.limits.door_height.min;
        },
        door_width() {
            const width = this.get('overall_width') - this.get('left_width') - this.get('right_width');

            if(isNaN(width)) {
                return 0;
            }

            return width;
        },
        door_height() {
            const height = this.get('overall_height') - this.get('top_box_drop');

            if(isNaN(height)) {
                return 0;
            }

            return height;

        },
        passed_filter() {
            return this.variable_ready(
                this.externalColour,
                this.internalColour,
                this.frameProfile,
                this.hardwareLock,
                this.hardwareHinge,
                this.hardwareHandle,
                this.hardwareHandleInternal,
                this.threshold,
                this.frameId,
                this.addons,
            ) && !Array.isArray(this.addons.left);
        },
        measurements() {
            if (this.option_list === null) {
                return [];
            }

            return this.option_list.measurements;
        },
        cache_key() {
            return '_' + this.fabricator
                + '_' + this.slab
                + '_' + this.externalColour
                + '_' + this.internalColour
                + '_' + this.frameProfile
                + '_' + this.threshold
                + '_' + this.hardwareLock
                + '_' + this.hardwareHinge
                + '_' + this.hardwareHandle
                + '_' + this.hardwareHandleInternal
                + '_' + this.hardwareKnocker
                + '_' + this.hardwareSpyHole
                + '_' + this.hardwareEscutcheon
                + '_' + this.hardwareLetterbox
                + '_' + this.hardwareLetterboxPosition
                + '_' + this.frameId
                + '_' + JSON.stringify(this.addons)
                + '_' + JSON.stringify(this.couplers)
                + '_' + this.cill
                + '_' + JSON.stringify(this.filteredSidePanels)
                + '_' + this.doorRange
                + '_' + this.cutToSize
                + '_' + this.hardwareRimLock
                + '_' + this.hardwareRimLockPosition
        },
        url() {
            return '/api/options/' + this.fabricator
                + '/measurements?slab=' + this.slab
                + '&external_colour=' + this.externalColour
                + '&door_colour_internal=' + this.internalColour
                + '&profile=' + this.frameProfile
                + '&threshold=' + this.threshold
                + '&hardware_lock=' + this.hardwareLock
                + '&hardware_hinge=' + this.hardwareHinge
                + '&hardware_handle=' + this.hardwareHandle
                + '&hardware_handle_internal=' + this.hardwareHandleInternal
                + '&hardware_knocker=' + this.hardwareKnocker
                + '&hardware_spy_hole=' + this.hardwareSpyHole
                + '&hardware_escutcheon=' + this.hardwareEscutcheon
                + '&hardware_letterbox=' + this.hardwareLetterbox
                + '&hardware_letterbox_position=' + this.hardwareLetterboxPosition
                + '&frame_style=' + this.frameId
                + '&addons=' + encodeURIComponent(JSON.stringify(this.addons))
                + '&couplers=' + encodeURIComponent(JSON.stringify(this.couplers))
                + '&cill=' + this.cill
                + '&side_panels=' + encodeURIComponent(JSON.stringify(this.filteredSidePanels))
                + '&door_range=' + this.doorRange
                + '&hardware_rim_lock=' + this.hardwareRimLock
                + '&hardware_rim_lock_position=' + this.hardwareRimLockPosition
        },
        filteredSidePanels() {

            let side_panels = JSON.parse(JSON.stringify(this.sidePanels));

            let valid_properties = {};

            valid_properties.left = side_panels.left;
            valid_properties.right = side_panels.right;
            valid_properties.left_composite_id = side_panels.left_composite_id;
            valid_properties.right_composite_id = side_panels.right_composite_id;

            return valid_properties;
        },
        raw_limits() {
            if (this.option_list === null) {
                return {
                    door_width: {
                        min: 0,
                        max: 0,
                    },
                    door_height: {
                        min: 0,
                        max: 0,
                    },
                    overall_width: {
                        min: 0,
                        max: 0,
                    },
                    overall_height: {
                        min: 0,
                        max: 0,
                    },
                }
            }

            return this.option_list.limits;
        },
        slab_width() {
            if (this.option_list === null) {
                return 0;
            }

            var slab_width = this.door_width + this.option_list.slab_width;

            if(isNaN(slab_width) || slab_width < 0) {
                return 0;
            }

            return slab_width;

        },
        slab_height() {
            if (this.option_list === null) {
                return 0;
            }

            var slab_height = this.door_height + this.option_list.slab_height;

            if(isNaN(slab_height) || slab_height < 0) {
                return 0;
            }

            return slab_height;

        },
        limits() {
            let limits = JSON.parse(JSON.stringify(this.raw_limits));

            if (limits.left_width !== undefined) {
                limits.left_width.min = this.calculateSideMin('left_width');
                limits.left_width.max = this.calculateSideMax('left_width');
            }

            if (limits.right_width !== undefined) {
                limits.right_width.min = this.calculateSideMin('right_width');
                limits.right_width.max = this.calculateSideMax('right_width');
            }

            if (limits.top_box_drop !== undefined) {
                limits.top_box_drop.min = this.calculateTopMin();
                limits.top_box_drop.max = this.calculateTopMax();
            }

            if (this.fabricator !== 34 && limits.flag_height !== undefined) {
                limits.flag_height.max = this.calculateFlagHeight();
            }

            return limits;
        },
        addon_height() {
            return this.option_list.addon_height;
        },
    },
    props: {
        target: {
            required: true,
            coerce(val) {
                if (typeof (val) !== 'object') {
                    return {};
                }

                return val;
            }
        },
        slab: {
            required: true,
        },
        frameId: {
            required: true,
        },
        externalColour: {
            required: true,
        },
        internalColour: {
            required: true,
        },
        frameProfile: {
            required: true,
        },
        threshold: {
            required: true,
        },
        sidePanels: {
            required: true,
            coerce(val) {
                if (typeof (val) !== 'object') {
                    return {};
                }

                return val;
            }
        },
        addons: {
            required: true,
        },
        couplers: {
            required: false,
            default() {
                return {};
            },
            coerce(val) {
                if (typeof (val) !== 'object') {
                    return {};
                }

                return val;
            },
        },
        cill: {
            required: true,
        },
        hardwareLock: {
            required: true,
        },
        hardwareHinge: {
            required: true,
        },
        hardwareHandle: {
            required: true,
        },
        hardwareHandleInternal: {
            required: false,
            default() {
                return 0;
            }
        },
        hardwareKnocker: {
            required: true,
        },
        hardwareSpyHole: {
            required: true,
        },
        hardwareLetterbox: {
            required: true,
        },
        hardwareEscutcheon: {
            required: true,
        },
        hardwareLetterboxPosition: {
            required: true,
        },
        doorRange: {
            required: false,
            default() {
                return '';
            }
        },
        cutToSize: {
            required: false,
            default() {
                return false;
            },
        },
        hardwareRimLock: {
            required: false,
            default() {
                return 0;
            }
        },
        hardwareRimLockPosition: {
            required: false,
            default() {
                return 0;
            }
        },
        mdd: {
            required: false,
            default() {
                return false;
            },
        },
        doorWidthAndHeightLabel: {
            required: false,
            default() {
                return 'Door Width x Height';
            }
        },
        extra_width_text: {
            required: false,
            default() {
                return null;
            }
        },
    },
    methods: {
        calculateSideMin(side) {
            let opposite_side = (side === 'left_width' ? 'right_width' : 'left_width');

            let total = this.calculateSmallest('overall_width');
            total -= this.raw_limits.door_width.max;
            total -= this.calculateLargest(opposite_side);
            total = Math.max(total, this.raw_limits[side].min);

            return total;
        },
        calculateSideMax(side) {
            let opposite_side = (side === 'left_width' ? 'right_width' : 'left_width');

            let total = this.calculateLargest('overall_width');
            total -= this.raw_limits.door_width.min;
            total -= this.calculateSmallest(opposite_side);
            total = Math.min(total, this.raw_limits[side].max);

            return total;
        },
        calculateTopMin() {
            let total = this.calculateSmallest('overall_height');
            total -= this.raw_limits.door_height.max;
            total = Math.max(total, this.raw_limits.top_box_drop.min);

            return total;
        },
        calculateTopMax() {
            let total = this.calculateLargest('overall_height');
            total -= this.raw_limits.door_height.min;
            total = Math.min(total, this.raw_limits.top_box_drop.max);

            return total;
        },
        calculateFlagHeight() {
            let overall_height = this.calculateLargest('overall_height');
            let top_box_drop = 0;
            if (this.raw_limits.top_box_drop) {
                top_box_drop = this.raw_limits.top_box_drop.max;
            }
            if (this.get('overall_height')) {
                overall_height = this.get('overall_height');
            }
            if (this.get('top_box_drop') && !this.raw_limits.flag_height.integrated_top) {
                top_box_drop = this.get('top_box_drop');
            } else {
                top_box_drop = 0;
            }
            let total = overall_height - top_box_drop;

            if (total < 0) {
                if (this.raw_limits.flag_height.integrated_top) {
                    top_box_drop = 0;
                } else {
                    top_box_drop = this.raw_limits.top_box_drop.max
                }
                total = this.calculateLargest('overall_height') - top_box_drop;
            }
            return Math.max(total, this.raw_limits.flag_height.min);
        },
        measurement_is_valid(measurement) {
            const value = this.get(measurement);
            return value >= this.raw_limits[measurement].min && value <= this.raw_limits[measurement].max;
        },
        calculateSmallest(measurement) {
            if (this.get(measurement) !== 0 && this.measurement_is_valid(measurement)) {
                return this.get(measurement);
            }

            return this.raw_limits[measurement] !== undefined ? this.raw_limits[measurement].min : 0;
        },
        calculateLargest(measurement) {
            if (this.get(measurement) !== 0 && this.measurement_is_valid(measurement)) {
                return this.get(measurement);
            }

            return this.raw_limits[measurement] !== undefined ? this.raw_limits[measurement].max : 0;
        },
        get(target) {
            if (this.target[target] === undefined) {
                return 0;
            }

            let found_in_list = this.measurements.findIndex((val) => {
                return val.slug === target;
            }) !== -1;

            if (!found_in_list) {
                return 0;
            }

            return parseInt(this.target[target]);
        },
        select_first() {
            // we don't need this function so block off parent
        },
        filterKey(key) {
            if (key.key === '.' || key.key === '-') {
                return key.preventDefault();
            }
        },
        filterInput(input) {
            input.target.value = input.target.value.replace(/[\.\-]+/g, '');
        },
        enter_max_sizes_for_retail() {
            var vueThis = this;
            nextTick(() => {
                if (vueThis.mdd && !vueThis.technical_should_show) {
                    const overall_height = vueThis.limits.overall_height;
                    const overall_width = vueThis.limits.overall_width;
                    const left_width = vueThis.limits.left_width;
                    const right_width = vueThis.limits.right_width;
                    const top_box_drop = vueThis.limits.top_box_drop;
                    const flag_height = vueThis.limits.flag_height;
                    const midrail_height = vueThis.limits.midrail_height;

                    if (overall_height) {
                        vueThis.localTarget.overall_height = vueThis.limits.overall_height.max.toString();
                    } else {
                        vueThis.localTarget.overall_height = null;
                    }

                    if (overall_width) {
                        vueThis.localTarget.overall_width = vueThis.limits.overall_width.max.toString();
                    } else {
                        vueThis.localTarget.overall_width = null;
                    }

                    if (left_width) {
                        vueThis.localTarget.left_width = vueThis.limits.left_width.max.toString();
                    } else {
                        vueThis.localTarget.left_width = null;
                    }

                    if (right_width) {
                        vueThis.localTarget.right_width = vueThis.limits.right_width.max.toString();
                    } else {
                        vueThis.localTarget.right_width = null;
                    }

                    if (top_box_drop) {
                        vueThis.localTarget.top_box_drop = vueThis.limits.top_box_drop.max.toString();
                    } else {
                        vueThis.localTarget.top_box_drop = null;
                    }

                    if (flag_height) {
                        vueThis.target.flag_height = vueThis.limits.flag_height.max.toString();
                    } else {
                        vueThis.target.flag_height = null;
                    }

                    if (midrail_height) {
                        vueThis.target.midrail_height = vueThis.limits.midrail_height.max.toString();
                    } else {
                        vueThis.target.midrail_height = null;
                    }

                }
            });
        },
        enter_min_sizes_for_retail() {
            var vueThis = this;
            nextTick(() => {
                if (vueThis.mdd && !vueThis.technical_should_show) {
                    const overall_height = vueThis.limits.overall_height;
                    const overall_width = vueThis.limits.overall_width;
                    const left_width = vueThis.limits.left_width;
                    const right_width = vueThis.limits.right_width;
                    const top_box_drop = vueThis.limits.top_box_drop;
                    const flag_height = vueThis.limits.flag_height;
                    const midrail_height = vueThis.limits.midrail_height;

                    if (overall_height) {
                        vueThis.localTarget.overall_height = vueThis.limits.overall_height.min.toString();
                    } else {
                        vueThis.localTarget.overall_height = null;
                    }

                    if (overall_width) {
                        vueThis.localTarget.overall_width = vueThis.limits.overall_width.min.toString();
                    } else {
                        vueThis.localTarget.overall_width = null;
                    }

                    if (left_width) {
                        vueThis.localTarget.left_width = vueThis.limits.left_width.min.toString();
                    } else {
                        vueThis.localTarget.left_width = null;
                    }

                    if (right_width) {
                        vueThis.localTarget.right_width = vueThis.limits.right_width.min.toString();
                    } else {
                        vueThis.localTarget.right_width = null;
                    }

                    if (top_box_drop) {
                        vueThis.localTarget.top_box_drop = vueThis.limits.top_box_drop.min.toString();
                    } else {
                        vueThis.localTarget.top_box_drop = null;
                    }

                    if (flag_height) {
                        vueThis.target.flag_height = vueThis.limits.flag_height.min.toString();
                    } else {
                        vueThis.target.flag_height = null;
                    }

                    if (midrail_height) {
                        vueThis.target.midrail_height = vueThis.limits.midrail_height.min.toString();
                    } else {
                        vueThis.target.midrail_height = null;
                    }


                }
            });
        },
    },
    watch: {
        'cache_key': {
            handler: function (val, oldVal) {
                this.update_options();
                if (this.fabricator === 8) {
                    this.enter_min_sizes_for_retail();
                } else {
                    this.enter_max_sizes_for_retail();
                }
            },
        },
        'limits': {
            handler: function (val, oldVal) {
                if (val !== []) {
                    window.emitter.emit('limits-updated', val)
                }

                this.update_options();

                if (this.fabricator === 8) {
                    this.enter_min_sizes_for_retail();
                } else {
                    this.enter_max_sizes_for_retail();
                }
            },
            deep: true,
        }
    }
}
</script>
